import React from "react";
import { FolderOpen } from "lucide-react";
import "../../../../styles/component/media-folder.scss";
import { Document } from "../../../../domains/models/document";
import { getImageUrl } from "../../../../utility/utility";

interface MediaFolderCoverProps {
    coverImage?: Document;
    profilePhoto?: Document;
    className?: string;
    type: string
}

const MediaFolderCover: React.FC<MediaFolderCoverProps> = ({type, className, coverImage, profilePhoto}) => {

    return (
        <>
            {!coverImage ? (
                <div
                    className={`media-folder-container__cover media-folder-container__cover--placeholder ${className}`}>
                    <div className={`media-folder-container__cover-content ${type}`}>
                        {profilePhoto ? (
                            <div className="media-folder-container__profile-wrapper">
                                <img
                                    src={getImageUrl(profilePhoto,'small')}
                                    alt="event-cover"
                                    className="media-folder-container__profile-image"
                                />
                            </div>
                        ) : (
                            <FolderOpen className="media-folder-container__icon"/>
                        )}
                    </div>
                </div>
            ) : (
                <img
                    src={getImageUrl(coverImage,'medium')}
                    alt="event-cover"
                    className={`media-folder-container__cover-image ${className}`}
                />
            )}
        </>
    );
};


export default MediaFolderCover;
